module.exports = __webpack_public_path__ + "img/depmap_svg_V198.95ec9ee0.svg";